<div class="border-card border-0 px-4 py-1 scroll-container" ref="manage_workflow">

  <div class="card mb-3 border-0 shadow-sm p-3 mt-3 rounded-lg">
    <div class="d-flex align-items-center">
      <i class="fa-solid fa-user fs-5 text-dark me-2"></i>
      <div class="d-flex flex-column justify-content-center">
        <span class="text-warning fw-bold text-xxs">In Progress</span>
      </div>
    </div>
  </div>

  <div class="overview-application-container">
    <div class="overview-vertical-tabs-container overview-scrollable-container">
      <div
        v-for="tab in visibleTabs"
        :key="tab.id"
        class="overview-floating-tab rounded"
        :class="{ 'active': activeTab === tab.id }"
        @click="selectTab(tab.id)"
      >
        <div class="overview-floating-tab-inner text-xs">
          <span>{{ tab.name }}</span>
        </div>
      </div>
    </div>

    <!-- Dropdown Section -->
    <div class="ms-4 overview-dropdown-column rounded-lg" v-if="activeTabHasDropdown">
      <div class="overview-accordion-container mb-3 border-0" id="stages_accordion">
        <div
          v-for="option in activeTabDropdownOptions"
          :key="option.value"
          class="accordion-item bg-secondary-dark"
        >
          <h2 class="accordion-header custom-header text-white border-0">
            <div
              class="d-flex align-items-center w-100 p-1 border-0 rounded text-xxs shadow bg-secondary-dark"
            >
              <div class="position-relative flex-grow-1 me-2">
                <span class="text-xs text-white">{{ option.label }}</span>
              </div>
              <a
                class="fw-bold fs-6 p-0 ms-2 text-dark"
                @click.stop="toggleDropdown(option.value)"
                type="button"
              >
                <i
                  class="bi"
                  :class="{
                    'text-white bi-chevron-down': selectedDropdown !== option.value,
                    'text-white bi-chevron-up': selectedDropdown === option.value
                  }"
                ></i>
              </a>
            </div>
          </h2>

          <div class="collapse" :class="{ show: selectedDropdown === option.value }">
            <div class="accordion-body p-2">
              <div v-if="selectedDropdown === 'trust information'">

                <div class="trust-details-form small">
                  <h6 class="fw-bold mb-3">Trust Details</h6>
                  <div class="form-group mb-2">
                    <label class="form-label small">Trust Name</label>
                    <input type="text" class="form-control form-control-sm" value="THE DA CODA PROPERTY TRUST">
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small">Application Date</label>
                    <input type="text" class="form-control form-control-sm" value="2023/9/25">
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small">Where will the greatest portion of assets be located? Or where will the bank be opened?</label>
                    <input type="text" class="form-control form-control-sm">
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small">Province</label>
                    <input type="text" class="form-control form-control-sm" value="Grazing">
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small">Master's Office</label>
                    <input type="text" class="form-control form-control-sm" value="ORGANISERABLE MASTERS OFFICE">
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small d-block">Is it a Family Business Trust?</label>
                    <div class="ps-3">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="familyBusiness" id="familyBusinessYes">
                        <label class="form-check-label small" for="familyBusinessYes">Yes</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="familyBusiness" id="familyBusinessNo">
                        <label class="form-check-label small" for="familyBusinessNo">No</label>
                      </div>
                    </div>
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small d-block">Are all beneficiaries related to one another?</label>
                    <div class="ps-3">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="beneficiariesRelated" id="beneficiariesRelatedYes">
                        <label class="form-check-label small" for="beneficiariesRelatedYes">Yes</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="beneficiariesRelated" id="beneficiariesRelatedNo">
                        <label class="form-check-label small" for="beneficiariesRelatedNo">No</label>
                      </div>
                    </div>
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small d-block">Are the Trustees all beneficiaries?</label>
                    <div class="ps-3">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="trusteesBeneficiaries" id="trusteesBeneficiariesYes">
                        <label class="form-check-label small" for="trusteesBeneficiariesYes">Yes</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="trusteesBeneficiaries" id="trusteesBeneficiariesNo">
                        <label class="form-check-label small" for="trusteesBeneficiariesNo">No</label>
                      </div>
                    </div>
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small">Source of Funds</label>
                    <button class="btn btn-sm btn-outline-secondary py-0">Close</button>
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small d-block">Annual Audit Required?</label>
                    <div class="ps-3">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="annualAudit" id="annualAuditYes">
                        <label class="form-check-label small" for="annualAuditYes">Yes</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="annualAudit" id="annualAuditNo">
                        <label class="form-check-label small" for="annualAuditNo">No</label>
                      </div>
                    </div>
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small">Number of beneficiaries</label>
                    <select class="form-select form-select-sm">
                      <option selected>Select Number of beneficiaries</option>
                    </select>
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small">City</label>
                    <input type="text" class="form-control form-control-sm" value="Jobsworkout">
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small d-block">Court Order Application?</label>
                    <div class="ps-3">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="courtOrder" id="courtOrderYes">
                        <label class="form-check-label small" for="courtOrderYes">Yes</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="courtOrder" id="courtOrderNo">
                        <label class="form-check-label small" for="courtOrderNo">No</label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group mb-2">
                    <label class="form-label small">Probable Trust Duration</label>
                    <input type="text" class="form-control form-control-sm" value="INDEFINITE">
                  </div>

                  <div class="form-group mb-2">
                    <label class="form-label small">Number of Trustees</label>
                    <input type="text" class="form-control form-control-sm" value="3">
                  </div>

                  
                  <div class="form-group mb-2">
                    <label class="form-label small">Minimum Number of Trustees allowed</label>
                    <input type="text" class="form-control form-control-sm" value="3">
                  </div>

                  <div class="form-group mb-2">
                    <label class="form-label small">Maximum Number of Trustees allowed</label>
                    <input type="text" class="form-control form-control-sm" value="3">
                  </div>
                </div>
                
                <div class="application-details-form small">
                  <h6 class="fw-bold mb-3">Trust Details</h6>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small">Trust Name</label>
                    <input type="text" class="form-control form-control-sm" value="THE DA CODA PROPERTY TRUST">
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small">Application Date</label>
                    <input type="text" class="form-control form-control-sm" value="2023/9/25">
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small">Where will the greatest portion of assets be located? Or where will the bank be opened?</label>
                    <input type="text" class="form-control form-control-sm">
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small">Province</label>
                    <input type="text" class="form-control form-control-sm" value="Grazing">
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small">Master's Office</label>
                    <input type="text" class="form-control form-control-sm" value="ORGANISERABLE MASTERS OFFICE">
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small d-block">Is it a Family Business Trust?</label>
                    <div class="ps-3">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="familyBusiness" id="familyBusinessYes">
                        <label class="form-check-label small" for="familyBusinessYes">Yes</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="familyBusiness" id="familyBusinessNo">
                        <label class="form-check-label small" for="familyBusinessNo">No</label>
                      </div>
                    </div>
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small d-block">Are all beneficiaries related to one another?</label>
                    <div class="ps-3">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="beneficiariesRelated" id="beneficiariesRelatedYes">
                        <label class="form-check-label small" for="beneficiariesRelatedYes">Yes</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="beneficiariesRelated" id="beneficiariesRelatedNo">
                        <label class="form-check-label small" for="beneficiariesRelatedNo">No</label>
                      </div>
                    </div>
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small d-block">Are the Trustees all beneficiaries?</label>
                    <div class="ps-3">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="trusteesBeneficiaries" id="trusteesBeneficiariesYes">
                        <label class="form-check-label small" for="trusteesBeneficiariesYes">Yes</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="trusteesBeneficiaries" id="trusteesBeneficiariesNo">
                        <label class="form-check-label small" for="trusteesBeneficiariesNo">No</label>
                      </div>
                    </div>
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small">Source of Funds</label>
                    <button class="btn btn-sm btn-outline-secondary py-0">Close</button>
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small d-block">Annual Audit Required?</label>
                    <div class="ps-3">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="annualAudit" id="annualAuditYes">
                        <label class="form-check-label small" for="annualAuditYes">Yes</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="annualAudit" id="annualAuditNo">
                        <label class="form-check-label small" for="annualAuditNo">No</label>
                      </div>
                    </div>
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small">Number of beneficiaries</label>
                    <select class="form-select form-select-sm">
                      <option selected>Select Number of beneficiaries</option>
                    </select>
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small">City</label>
                    <input type="text" class="form-control form-control-sm" value="Jobsworkout">
                  </div>
                  
                  <div class="form-group mb-2">
                    <label class="form-label small d-block">Court Order Application?</label>
                    <div class="ps-3">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="courtOrder" id="courtOrderYes">
                        <label class="form-check-label small" for="courtOrderYes">Yes</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="courtOrder" id="courtOrderNo">
                        <label class="form-check-label small" for="courtOrderNo">No</label>
                      </div>
                    </div>
                  </div>
                </div>

              
              </div>
              <div v-if="selectedDropdown === 'main contact details'">
                <!-- <VerificationOverview /> -->
              </div>
              <div v-if="selectedDropdown === 'founders details'">
                <!-- <div class="mb-3 rounded-lg p-2 border border-color mt-1">
                  <EntityForm :profile_role_form_id="profile_role_form_id" />
                </div> -->
              </div>
              <div v-if="selectedDropdown === 'trustees'">
                <!-- <InvoiceOverview /> -->
              </div>
              <div v-if="selectedDropdown === 'beneficiary information'">
                <!-- <ApplicationContracts :profile_role_form_id="profile_role_form_id" :form_id="form_id" :profile_role_id="profile_role_id" :role_id="role_id" :user_id="user_id"/> -->
              </div>
              <div v-if="selectedDropdown === 'auditors information'">
                <!-- <ViewComplianceChecks :profile_role_form_id="entity_id" /> -->
              </div>
              <div v-if="selectedDropdown === 'bond security'">
                <!-- <p class="text-center text-muted">Comms coming soon.</p> -->
              </div>
              <div v-if="selectedDropdown === 'supporting documents'">
                <!-- <p class="text-center text-muted">Activity coming soon.</p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>